import { gql } from '@apollo/client';
import { UserInfoShared } from '../fragments';

export default gql`
  query user($id: ID) {
    user(id: $id) {
      ...UserInfoShared
    }
  }
  ${UserInfoShared}
`;
